import styles from './headerSection.module.scss'
import Container from "react-bootstrap/esm/Container";
import {Alert} from "react-bootstrap";
import {useState} from "react";
import When from "../../../../components/When";

export function HeaderSection() {
    const [show, setShow] = useState(true);

    return (
        <When condition={show}>
            <Container className={styles.container}>
                <Alert variant="info" onClose={() => setShow(false)} dismissible>I formuläret nedan fyller du i en
                    olycka eller tillbud som inträffat på arbetsplatsen. Försök att
                    vara så utförlig som möjligt.</Alert>
            </Container>
        </When>
    );
}